const terveystaloOnlineOrigins = [
  'https://tap-dev.test.terveystalo.com',
  'https://www.test.terveystalo.com',
  'https://www.stg.terveystalo.com',
  'https://www.terveystalo.com',
];

const prspOrigins = [
  'https://etapalvelualusta-dev.test.terveystalo.com',
  'https://etapalvelualusta-demo.test.terveystalo.com',
  'https://etapalvelualusta-stg.test.terveystalo.com',
  'https://etapalvelualusta-prod.test.terveystalo.com',
  'https://www.etapalvelut.fi',
  'https://etapalvelut.fi',
];

/**
 * Allowed origins where the HTA can be embedded in
 */
export const allowedOrigins = [
  ...terveystaloOnlineOrigins,
  ...prspOrigins,
  'http://localhost:3000',
  'https://localhost:3000',
  'http://localhost:3001',
  'https://localhost:3001',
  'https://stwe-ada-test-hta-cdne.azureedge.net',
  'https://hta-test.test.terveystalo.com',
  'https://hta.test.terveystalo.com',
  'https://hta-stg.test.terveystalo.com',
  'https://hta.terveystalo.com',
];

/**
 * Checks if the app is embedded in Terveystalo Online. This is derived from the document.referrer, so the
 * iframe in Terveystalo Online needs to allow passing in the header.
 */
export const isEmbeddedToTerveystaloOnline =
  document.referrer !== '' ? terveystaloOnlineOrigins.includes(new URL(document.referrer).origin) : false;

/**
 * Checks if the app is embedded in Terveystalo PRSP. This is derived from the document.referrer, so the
 * iframe in Terveystalo PRSP needs to allow passing in the header.
 */
export const isEmbeddedToPRSP =
  document.referrer !== '' ? prspOrigins.includes(new URL(document.referrer).origin) : false;

/**
 * Checks if the app is embedded in Terveystalo mobile application.
 * This is determined by the particular window object or the lack of it
 */
export const isEmbeddedToTTApp = window.terveystaloApp ?? false;
